/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ItemWrap } from '@/components/layouts/ItemWrap';
import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { DpContainer } from '@/components/blocks/DpContainer';
import { ShowByCondition } from '@/components/blocks/ShowByCondition';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { usePersonalizationPromotionId } from '@/data/Content/RepurchaseCoupon';

const FAN_CARD_ESPOT = 'DPSV2DPFanCardAction';

export const AsideExtended: FC<{ layout: Layout }> = ({ layout }) => {
	const isMobile = useIsMobile();
	const promotionId = usePersonalizationPromotionId();
	const thirdItems = promotionId
		? layout?.slots.third?.filter(({ properties }) => properties?.emsName !== FAN_CARD_ESPOT)
		: layout?.slots.third;

	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
			<Stack component="main" sx={layoutMainSX(layout.slots.first?.length ?? 0)}>
				<ShowByCondition
					condition={layout.slots.first ? !!layout.slots.first[0]?.properties : false}
				>
					<LayoutSlot slot={layout.slots.first} ItemWrap={ItemWrap} />
				</ShowByCondition>
				<LayoutSlot slot={layout.slots.second} />
				<DpContainer isPLP component="section" withoutmargin={isMobile}>
					<Box>
						<Stack direction="row" spacing="48px">
							<Stack component="aside" sx={{ minWidth: '300px', maxWidth: '300px' }}>
								<LayoutSlot slot={layout.slots.aside} />
							</Stack>
							{!isMobile ? (
								<Stack sx={{ width: '100%' }} component="section">
									<LayoutSlot slot={thirdItems} />
								</Stack>
							) : null}
						</Stack>
					</Box>
				</DpContainer>
				{isMobile ? (
					<Stack component="section">
						<LayoutSlot slot={thirdItems} ItemWrap={ItemWrap} />
					</Stack>
				) : null}
				<LayoutSlot slot={layout.slots.fourth} />
				<LayoutSlot slot={layout.slots.footer} />
			</Stack>
		</>
	) : null;
};
